import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

declare var window: any;

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  /**
   * Constructor
   * @param {ActivatedRoute} private activatedRoute Current route snapshot and observables from Angular
   * @param {Location}       private location       Angular object to manipulate browser location
   * @param {Router}         private router         Angular router service to make route navigations
   */
  constructor(private activatedRoute: ActivatedRoute, private location: Location, private router: Router) {}

  /**
   * Build URL query string, supports nesting of objects or arrays upto one level only
   * @param  {any = {}}        queryParams Query params to build into string
   * @return {string}   Query string
   */
  buildQueryString(queryParams: any = {}): string {
    let queryItems: Array<string> = [];
    console.log('Building query string');
    console.log(queryParams);
    for (let key in queryParams) {
      let paramValue: any = queryParams[key];
      console.log(typeof paramValue, Array.isArray(paramValue), key, paramValue);
      if (typeof paramValue == 'object') {
        if (Array.isArray(paramValue)) {
          for (let i = 0; i < paramValue.length; i++) queryItems.push(`${window.encodeURIComponent(key + '[]')}=${window.encodeURIComponent(paramValue[i])}`);
        } else for (let levelOneKey in paramValue) queryItems.push(`${window.encodeURIComponent(key + '[' + levelOneKey + ']')}=${window.encodeURIComponent(paramValue[levelOneKey])}`);
      } else queryItems.push(`${window.encodeURIComponent(key)}=${window.encodeURIComponent(paramValue)}`);
    }
    return queryItems.join('&');
  }

  /**
   * Retrieve query params from URL and merge with previous query params
   * @param  {any = {}}        previousParams Previous query params, empty object if not provided
   * @return {any}      Current query params
   */
  retrieveQueryParams(previousParams: any = {}, activatedRoute: ActivatedRoute | null = null): any {
    if (!activatedRoute) activatedRoute = this.activatedRoute;
    console.log('qps', previousParams, Object.assign({}, activatedRoute.snapshot.queryParams));
    console.log(Object.assign({}, this.activatedRoute.snapshot.queryParams));
    return Object.assign({}, previousParams, activatedRoute.snapshot.queryParams);
  }

  /**
   * Set query params to current URL
   * @param {any}    queryParams Query params to set
   */
  setQueryParams(queryParams: any, url: string) {
    /**
     * Old code for ref: to be removed later
     * this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: Object.assign({}, this.filterOptions),
      queryParamsHandling: 'merge',
      // preserve the existing query params in the route
      // skipLocationChange: true
      // do not trigger navigation
    });
    //this.router.navigateByUrl('/events', {fragment: 'top', queryParams: Object.assign({}, this.filterOptions), replaceUrl: true, skipLocationChange: true});
     */
    this.router.navigateByUrl(url, /* Removed unsupported properties by Angular migration: queryParams. */ {});
    this.location.replaceState(url, this.buildQueryString(queryParams));
  }
}
